import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { EnvService } from './env.service';
import { CheckDigitalProfileResponse, GetPhoneByWalletRes, ValidateEmailResponse } from '../models/sign-in.models';
import { ConsumerDetails, DateOfBirth, RegisterProfilePayload, UserRegistration } from '../feature/sign-in/pages/user-profile/model/model.userProfileForm';

@Injectable({
  providedIn: 'root'
})
export class SignInService {

  constructor( private http: HttpClient, private envService: EnvService ) { }

  private getPhoneUrl(envApiUrl: string, walletAddress: string): string {
    return `${envApiUrl}/v2/profile?providerAccountAddress=${walletAddress}`
  }

  // GET - /stellaradapterservice/v2/profile?providerAccountAddress={someWalletAddress}
  async getPhoneByWallet(walletId: string): Promise<any> { // Todo: tim: fix types
    let result;
    // walletId = 'BekTestAddress6' // TODO: remove: #feb11 mock param
    try {
      result = await firstValueFrom(this.http.get(this.getPhoneUrl(this.envService.apiUrl, walletId)));
      return result;
    } 
    catch (error) {
      // Todo: Tim: this is the wrong way to handle errors. We should throw the error to the function calling this function.
      console.error('error gettingprofile by walletId', error);
      const errPromise = new Promise((resolve, reject) => {
        resolve({error: true});
      });
      return errPromise;
    }
  }

  // POST - /stellaradapterservice/v2/profile/pre-check 
  // req {
  //   "phoneNumber": "6124816161",
  //   "countryDialCode": "1"
  // }
  async checkDigitalProfile(phoneNumber: string | null, countryDialCode: string | null): Promise<CheckDigitalProfileResponse> {
    console.log('checkDigitalProfile phoneNumber -', phoneNumber); // TOdo: remove:
    console.log('checkDigitalProfile countryDialCode -', countryDialCode); // TOdo: remove:

    let result: any; // Todo: Tim: fix types

    const payload = {
      phoneNumber: phoneNumber,
      countryDialCode: countryDialCode
    }

    try {
      result = await firstValueFrom(this.http.post(`${this.envService.apiUrl}/v2/profile/pre-check`, payload)); // Todo: Revert when APIs are working again
      console.log('return value from checkDigitalProfile', result); // Todo: remove:
      return result;
    } 
    catch (error) {
      console.error('error checkDigitalProfile', error);
      const errPromise = new Promise<CheckDigitalProfileResponse>((resolve, reject) => {
        resolve({profileExists: false, error: true});
      });
      return errPromise;
    }
  }

  // POST - /stellaradapterservice/v2/profile/validate
  // HEADER X-Firebase-Auth: {some value}
  // req {
  //   "emailAddress": "email@example.com",
  //   "phoneNumber": "6124816161",
  //   "countryDialCode": "1"
  // }
  // res { // 201 OK
  //   "digitalProfileId": "14735924"
  // }
  // async validateEmail(phoneNumber: string | null, countryDialCode: string | null, emailAddress: string, userAuthToken: string): Promise<ValidateEmailResponse> {
  //   // Todo: Tim: Need to pass X-Firebase-Auth with #Firebase Auth token as a HEADER
  //   let result: any; // Todo: Tim: fix types

  //   const payload = {
  //     phoneNumber: phoneNumber,
  //     countryDialCode: countryDialCode,
  //     emailAddress: emailAddress
  //   }

  //   const headers = new HttpHeaders({
  //     'X-Firebase-Auth': userAuthToken
  //   })

  //   try {
  //     result = await firstValueFrom(this.http.post(`${this.envService.apiUrl}/v2/profile/validate`, payload, { headers }));
  //     console.log('return value from validateEmail', result); // Todo: remove:
  //     return result;
  //   } 
  //   catch (error) {
  //     console.error('error validateEmail', error);
  //     const errPromise = new Promise<ValidateEmailResponse>((resolve, reject) => {
  //       resolve({valid: false, error: true});
  //     });
  //     return errPromise;
  //   }
  // }

  // POST - /stellaradapterservice/v2/profile
  // HEADER X-Firebase-Auth: {some value}
  // {
  //   "targetAudience": null,
  //   "userLanguage": "en-US",
  //   "productType": "MGX",
  //   "digitalProfileType": "DPID",
  //   "consumer": {
  //     "firstName": "Bek",
  //     "middleName": "",
  //     "lastName": "Tester",
  //     "secondLastName": "",
  //     "genderCode": null,
  //     "address": {
  //       "line1": "Islas borneo 1",
  //       "line2": "",
  //       "line3": null,
  //       "city": "Mexicali",
  //       "countrySubdivisionCode": "MX-BCN",
  //       "countryCode": "MEX",
  //       "postalCode": "21330"
  //     },
  //     "mobilePhone": {
  //       "number": "6124816161",
  //       "countryDialCode": "1"
  //     },
  //     "email": "oatadjanov@moneygram.com",
  //     "enrolInRewards": null,
  //     "notificationPreferences": null,
  //     "notificationLanguagePreference": null,
  //     "dateOfBirth": "1945-10-07",
  //     "birthCity": null,
  //     "birthCountryCode": "MEX",
  //     "citizenshipCountryCode": null
  //   },
  //   "additionalDetails": [
  //     {
  //         "key": "providerAccountAddress",
  //         "value": "BekTestAddress6"
  //     }
  //   ]
  // }
  public async registerNewProfile(consumerProfile: UserRegistration, userWalletId: string, userEmail: string, userPhoneNumber: string, userDialCode: string, userAuthToken: string): Promise<any> { // Todo: Tim: add interface for profile // TOdo: fix types
    console.log('registerNewProfile consumerProfile -', consumerProfile); // TOdo: remove:
    // Todo: Tim: Need to pass X-Firebase-Auth with Firebase Auth token as a HEADER

    let result;

    // Todo: Tim: build Payload
    const payload: RegisterProfilePayload = this.buildProfilePayload(consumerProfile, userWalletId, userEmail, userPhoneNumber, userDialCode);

    const headers = new HttpHeaders({
      'X-Firebase-Auth': userAuthToken
    })

    try {
      result = await firstValueFrom(this.http.post(`${this.envService.apiUrl}/v2/profile`, payload, { headers }));
      console.log('return value from registerNewProfile', result); // Todo: remove:
      return result;
    } 
    catch (error) {
      console.error('error registerNewProfile', error);
      const errPromise = new Promise((resolve, reject) => {
        resolve({error: true});
      });
      return errPromise;
    }
  }

  // Todo: Tim: this is a pure function, move this to a utils file
  private buildProfilePayload(consumerProfile: UserRegistration, userWalletId: string, userEmail: string, userPhoneNumber: string, userDialCode: string): RegisterProfilePayload {
    let profilePayload: RegisterProfilePayload;
    profilePayload = {
      targetAudience: null,
      userLanguage: "",
      productType: "MGX",
      digitalProfileType: "DPID",
      consumer: {
        firstName: consumerProfile.firstName,
        middleName: consumerProfile.middleName,
        lastName: consumerProfile.lastName,
        secondLastName: "",
        genderCode: null,
        address: {
          line1: consumerProfile.address,
          line2: "",
          line3: null,
          city: consumerProfile.cityOrTown,
          countrySubdivisionCode: consumerProfile.state,
          countryCode: consumerProfile.country,
          postalCode: consumerProfile.postalCode
        },
        mobilePhone: {
          number: userPhoneNumber,
          countryDialCode: userDialCode
        },
        email: userEmail,
        enrolInRewards: null,
        notificationPreferences: null,
        notificationLanguagePreference: null,
        dateOfBirth: this.convertDOBtoString(consumerProfile.dateOfBirth),
        birthCity: null,
        birthCountryCode: consumerProfile.countryOfBirth,
        citizenshipCountryCode: null
      },
      additionalDetails: [
        {
            key: "providerAccountAddress",
            value: userWalletId 
        }
      ]
    };
    console.log('profilePayload', profilePayload); // Todo: remove:
    return profilePayload;
  }

  private convertDOBtoString(dateOfBirth: DateOfBirth): string {
    let dobString: string = `${dateOfBirth.year}-${dateOfBirth.month}-${dateOfBirth.day}`;
    return dobString;
  }
}
